// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import store from './store'
import VueTagsInput from '@johmun/vue-tags-input';
// import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
import store from './store/store.js'
import Vuex from "vuex";
import axios from 'axios';



Vue.config.productionTip = false

// Vue.prototype.$http = Axios;
// const token = localStorage.getItem('token')
// if(token){
//   Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
// }

Vue.use(Vuex);

axios.interceptors.request.use((config) => {
    const authToken = store.getters['getUserToken'];
    // console.log("Header token: " + authToken);
    if (authToken) {
      // console.log("Add token to request");
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  }, (err) => {
    return Promise.reject(err);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js